import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  GetAllEmployees,
  getPartsListByStoreFilter,
  ReceiveWbApi,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { useStateContext } from "../../contexts/ContextProvider";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import DateTimeField from "../../components/DateTimeField";
import DateInputField from "../../components/DateInputField";

const ReceiveWb = () => {
  const navigate = useNavigate();
  const { storeG, currentColor, userID } = useStateContext();
  const [getParts, setParts] = useState([]);
  const [getEmployees, setEmployees] = useState([]);
  const [snList, setSnList] = useState([]);
  const [formData, setFormData] = useState({
    part: "Select Part",
    wb_name: "",
    specs: "",
    detail: "",
    qty: "1",
    employee: "Select Employee",
  });
  const [snData, setSnData] = useState({
    qrscan: "",
    wb_sn: "",
    id_no1: "",
    id_no2: "",
    prod_date: null,
    test: "PASS",
    other: "",
    note: "",
  });
  const [oDatetime, setODatetime] = useState("");
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "qrscan") {
      if (value.length > 74) {
        const strings = value.split(">");
        if (strings.length === 4) {
          const idn1 = strings[0].indexOf("P") || "";
          const snin = strings[1].indexOf("R") || "";
          const idn2 = strings[2].indexOf("111N") || "";
          if (idn1 !== -1 && snin !== -1 && idn2 !== -1) {
            const prd = strings[0].length >= 9 ? strings[0].slice(2, 8) : "";
            const res = strings[3].length > 5 ? strings[3].slice(-4) : "";
            const prdd =
              prd.length === 6
                ? new Date(
                    `20${prd.slice(0, 2)}-${prd.slice(2, 4)}-${prd.slice(4, 6)}`,
                  )
                : null;
            setSnData((prev) => ({
              ...prev,
              [name]: value,
              id_no1: strings[0].slice(idn1),
              id_no2: strings[2].slice(idn2),
              wb_sn: strings[1].slice(snin),
              prod_date: prdd
                ? prdd.toISOString().slice(0, 19).split("T")[0]
                : null,
              test: res === "FAIL" ? res : "PASS",
            }));
          } else setSnData((prev) => ({ ...prev, [name]: value }));
        } else setSnData((prev) => ({ ...prev, [name]: value }));
      } else setSnData((prev) => ({ ...prev, [name]: value }));
    } else if (
      name === "wb_sn" ||
      name === "id_no1" ||
      name === "id_no2" ||
      name === "prod_date" ||
      name === "other" ||
      name === "note"
    )
      setSnData((prev) => ({ ...prev, [name]: value }));
    else if (name === "qty")
      setFormData((prev) => ({ ...prev, [name]: parseInt(value) || 0 }));
    else setFormData((prev) => ({ ...prev, [name]: value }));

    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      if (e.name === "part")
        setFormData((prev) => ({
          ...prev,
          [e.name]: option,
          wb_name: option.label,
        }));
      else setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleRadioChange = (e) => {
    const name = e.target.value;
    setSnData((prev) => ({ ...prev, test: name }));
  };

  const handleNext = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    const newErrors = {};
    Object.keys(snData).forEach((key) => {
      const error = validateField(key, snData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    if (snList.some((item) => item.wb_sn === snData.wb_sn)) {
      showErrorToast("Duplicate SN!", "This Water Block SN already exists!");
      setLoadBtn(false);
      return;
    }
    const coun = snList.length + 1;
    if (parseInt(formData.qty) < coun + 1)
      setFormData((prev) => ({ ...prev, qty: parseInt(formData.qty) + 1 }));
    setSnList((prev) => [
      ...prev,
      {
        qrscan: snData.qrscan,
        wb_sn: snData.wb_sn,
        id_no1: snData.id_no1,
        id_no2: snData.id_no2,
        prod_date: snData.prod_date,
        test: snData.test,
        other: snData.other,
        note: snData.note,
      },
    ]);
    setSnData((prev) => ({
      ...prev,
      qrscan: "",
      wb_sn: "",
      id_no1: "",
      id_no2: "",
      prod_date: null,
      test: "PASS",
      other: "",
      note: "",
    }));
  };

  const handleFinish = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    const newErrors = {};
    Object.keys(snData).forEach((key) => {
      const error = validateField(key, snData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    if (snList.some((item) => item.wb_sn === snData.wb_sn)) {
      showErrorToast("Duplicate SN!", "This Water Block SN already exists!");
      setLoadBtn(false);
      return;
    }
    setSnList((prev) => [
      ...prev,
      {
        qrscan: snData.qrscan,
        wb_sn: snData.wb_sn,
        id_no1: snData.id_no1,
        id_no2: snData.id_no2,
        prod_date: snData.prod_date,
        test: snData.test,
        other: snData.other,
        note: snData.note,
      },
    ]);
    setSnData((prev) => ({
      ...prev,
      qrscan: "",
      wb_sn: "",
      id_no1: "",
      id_no2: "",
      prod_date: "",
      test: "",
      other: "",
      note: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    const snItems = snList.map((item, i) => ({
      name: formData.wb_name,
      specs: formData.specs,
      detail: formData.detail,
      prod_date: item.prod_date || null,
      qrcode: item.qrscan,
      id_no1: item.id_no1,
      id_no2: item.id_no2,
      sn: item.wb_sn,
      test_result: item.test,
      other: item.other,
      notes: item.note,
    }));
    const reqData = {
      part_id: formData.part.value,
      store_id: storeG.store_id,
      employee_id: formData.employee.value,
      user_id: userID,
      recv_scan_date: oDatetime,
      water_blocks: snItems,
    };
    try {
      const response = await ReceiveWbApi(reqData);
      if (response.success) {
        showSuccessToast("Success!", "WBs Received successfully!");
        navigate("/GpuWb");
      } else
        showErrorToast("Error!", "WBs failed to recv!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "WBs did not receive!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        var now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        setODatetime(now.toISOString().slice(0, 19));
        await GetAllEmployees()
          .then((resp) => {
            const employeeOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.employee_id,
            }));
            setEmployees(employeeOptions || []);
          })
          .catch((err) => console.log(err.message));
        await getPartsListByStoreFilter(storeG?.store_id, "water block")
          .then((resp) => {
            const partOptions = resp.data.map((item) => ({
              label: item.part_number + " - " + item.description,
              value: item.part_id,
            }));
            setParts(partOptions || []);
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="RECEIVE WATER BLOCKS" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={8} lg={12} className="container-col">
              <SelectField
                label="Part:"
                name="part"
                value={formData.part}
                options={getParts}
                onChange={handleSelectChange}
                placeholder="Part"
                compulsory={true}
                error={errors.part}
              />
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={4} lg={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Name:"
                  name="wb_name"
                  value={formData.wb_name}
                  onChange={handleChange}
                  placeholder="Name"
                  error={errors.wb_name}
                />
                <TextInputField
                  label="Specs:"
                  name="specs"
                  value={formData.specs}
                  onChange={handleChange}
                  placeholder="Specs"
                  error={errors.specs}
                />
                <TextAreaField
                  label="Detail:"
                  name="detail"
                  value={formData.detail}
                  onChange={handleChange}
                  placeholder="Detail"
                  error={errors.detail}
                />
                <div style={{ marginTop: "94px" }} />
                <DoubleField
                  label="Recv Qty:"
                  name="qty"
                  value={formData.qty}
                  onChange={handleChange}
                  placeholder="Receive Quantity"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.qty}
                />
                <SelectField
                  label="Recv Operator:"
                  name="employee"
                  value={formData.employee}
                  options={getEmployees}
                  onChange={handleSelectChange}
                  placeholder="Operator"
                  compulsory={true}
                  error={errors.employee}
                />
                <DateTimeField
                  label="Recv Datetime:"
                  name="recv_date"
                  value={oDatetime}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
              </div>
            </Col>
            <Col xl={4} lg={6} className="container-col">
              <Row sm={1} className="p-0 justify-content-center">
                <Col md={2} className="pt-3 container-col">
                  {parseInt(formData.qty) <= snList.length
                    ? "-"
                    : `${snList.length + 1}.`}
                </Col>
                <Col md={10} className="container-col">
                  <div className="col-lg-12">
                    <TextAreaField
                      label="QR Scan:"
                      name="qrscan"
                      value={snData.qrscan}
                      onChange={handleChange}
                      placeholder="QR Scan"
                      error={errors.qrscan}
                      disabled={parseInt(formData.qty) <= snList.length}
                    />
                    <TextInputField
                      label="SN:"
                      name="wb_sn"
                      value={snData.wb_sn}
                      onChange={handleChange}
                      placeholder="SN"
                      error={errors.wb_sn}
                      compulsory={true}
                      disabled={parseInt(formData.qty) <= snList.length}
                    />
                    <TextInputField
                      label="ZOOX ID No:"
                      name="id_no1"
                      value={snData.id_no1}
                      onChange={handleChange}
                      placeholder="ZOOX ID No"
                      error={errors.id_no1}
                      disabled={parseInt(formData.qty) <= snList.length}
                    />
                    <TextInputField
                      label="PNY ID No:"
                      name="id_no2"
                      value={snData.id_no2}
                      onChange={handleChange}
                      placeholder="PNY ID No"
                      error={errors.id_no2}
                      disabled={parseInt(formData.qty) <= snList.length}
                    />
                    <DateInputField
                      label="Prod Date:"
                      name="prod_date"
                      value={snData.prod_date}
                      onChange={handleChange}
                      placeholder="Prod Date"
                      error={errors.prod_date}
                      disabled={parseInt(formData.qty) <= snList.length}
                    />
                    <label className="label mt-3">Test Result:</label>
                    <div className="text-md flex gap-10 justify-content-center mr-16 mt-2">
                      <label>
                        <input
                          type="radio"
                          value="PASS"
                          id="auto"
                          name="type"
                          onChange={handleRadioChange}
                          style={{ marginRight: "4px" }}
                          checked={snData.test === "PASS"}
                          disabled={parseInt(formData.qty) <= snList.length}
                        />
                        PASS
                      </label>
                      <label>
                        <input
                          type="radio"
                          value="FAIL"
                          id="auto"
                          name="type"
                          onChange={handleRadioChange}
                          style={{ marginRight: "4px" }}
                          checked={snData.test === "FAIL"}
                          disabled={parseInt(formData.qty) <= snList.length}
                        />
                        FAIL
                      </label>
                    </div>
                    <p className="label-error mb-4">{errors.test}</p>
                    <TextInputField
                      label="Other:"
                      name="other"
                      value={snData.other}
                      onChange={handleChange}
                      placeholder="Other"
                      error={errors.other}
                      disabled={parseInt(formData.qty) <= snList.length}
                    />
                    <TextAreaField
                      label="Note:"
                      name="note"
                      value={snData.note}
                      onChange={handleChange}
                      placeholder="Note"
                      error={errors.note}
                      disabled={parseInt(formData.qty) <= snList.length}
                    />
                    <Row md={"auto"} className="justify-content-center pr-12">
                      <button
                        type="button"
                        style={{
                          backgroundColor:
                            parseInt(formData.qty) <= snList.length
                              ? "gray"
                              : currentColor,
                          color: "#fff",
                          borderRadius: "10px",
                          padding: "12px",
                          margin: "4px",
                        }}
                        disabled={parseInt(formData.qty) <= snList.length}
                        className={`text-sm pt-2 pb-2 pl-3 pr-3 hover:drop-shadow-xl transition disabled:cursor-not-allowed`}
                        onClick={handleNext}
                      >
                        Next
                      </button>
                      <button
                        type="button"
                        style={{
                          backgroundColor:
                            parseInt(formData.qty) <= snList.length
                              ? "gray"
                              : currentColor,
                          color: "#fff",
                          borderRadius: "10px",
                          padding: "12px",
                          margin: "4px",
                        }}
                        disabled={parseInt(formData.qty) <= snList.length}
                        className={`text-sm pt-2 pb-2 pl-3 pr-3 hover:drop-shadow-xl transition disabled:cursor-not-allowed`}
                        onClick={handleFinish}
                      >
                        Finish
                      </button>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Create"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ReceiveWb;
